/* eslint-disable implicit-arrow-linebreak */
import { useNamespace, useStripes } from '@folio/stripes/core';
import { useQuery } from 'react-query';
import useTenantKy from './useTenantKy';

export default function useHoldings(instanceId) {
  const {
    okapi: { tenant },
  } = useStripes();

  const ky = useTenantKy({ tenantId: tenant });
  const [namespace] = useNamespace({ key: 'holding' });

  const {
    isLoading,
    isError,
    data = {},
    refetch,
    ...rest
  } = useQuery(
    [namespace, instanceId, tenant],
    () =>
      ky
        .get(
          `holdings-storage/holdings?limit=5000&query=(instanceId==${instanceId})`,
        )
        .json(),
    {
      enabled: Boolean(instanceId),
    },
  );

  return {
    holdings: data?.holdingsRecords,
    isHoldingsLoading: isLoading,
    isError,
    refetch,
    ...rest,
  };
}
